import { render, staticRenderFns } from "./ConsoleItem.vue?vue&type=template&id=4419f528&scoped=true&"
import script from "./ConsoleItem.vue?vue&type=script&lang=ts&"
export * from "./ConsoleItem.vue?vue&type=script&lang=ts&"
import style0 from "./ConsoleItem.vue?vue&type=style&index=0&id=4419f528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4419f528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
